import React from "react";
import PropTypes from "prop-types";
import Image from "../ImageElement";
import "../../css/Cards/Card.css";
import ChevronRight from "../../svg/ICON_chevronRight_Dark.svg";

/**
 * CardChroniqueHome component
 */
class CardChroniqueHome extends React.Component {
  static displayName = "CardChroniqueHome";
  static propTypes = {
    className: PropTypes.string,
    chronique: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Card";
  }

  /**
   * @override
   */
  render() {
    if (!this.props.chronique) return false;
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div
          className={`${this.className}__title`}
          dangerouslySetInnerHTML={{
            __html: this.props.title,
          }}
        />
        <div className={`${this.className}__content`}>
          <div className={`${this.className}__img`}>
            {
              <Image
                src={this.props.chronique.cover()[`${this.props.screen}_src`]}
                alt={this.props.chronique.cover().alt}
              />
            }
          </div>
          <h1
            style={{ marginBottom: 0, marginTop: "1rem", width: "100%" }}
            dangerouslySetInnerHTML={{
              __html: this.props.chronique.Title,
            }}
          />
          <div className={`${this.className}__text`}>
            <div
              className={`${this.className}__html`}
              dangerouslySetInnerHTML={{
                __html:
                  this.props.chronique.SummaryTextOriginal +
                  this.props.chronique.Text,
              }}
            />
          </div>
          <div className={`${this.className}__link--btn`}>
            <a href={this.props.link}>
              Lire la suite
              <img src={ChevronRight} className="icon" alt=">" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default CardChroniqueHome;



// WEBPACK FOOTER //
// ./src/components/Cards/CardChroniqueHome.js